class Prestador {
  constructor(idLetradoCiaPrestador,razonSocial,cuit){
    this.id=idLetradoCiaPrestador
    this.descripcion=cuit + ' - ' + razonSocial
    this.razonSocial=razonSocial
    this.cuit=cuit
  }
} 

export default Prestador
